import React from 'react';
import SubmissionAbstract from "../SubmissionAbstract";
import View from "../View/View";
import {
  withFormControl,
  PuzzleButton,
  PuzzleToolbar
} from "puzzle";
import { config, tptConfig } from "../Create/Create.config";
import PoliciesManager from "../../util/Policies";
import { Container } from "puzzle";

export type PROPS = {
  submissionMode: boolean
};

export type STATE = {}

class Clone extends SubmissionAbstract<PROPS, STATE> {
  static defaultProps = {
    submissionMode: 'CLONE',
    dispatcherUpdateStates: {
      uploadFlowState: {}
    }
  };

  /**
   * Cancel button handler, prompts warning window and redirects to previous path
   */
  onCancel = () => {
    this.dispatch('checkForChangesBeforeRedirect', '', { leaveAction: 'goBack' })
  }

  renderBody() {
    const {
      batchesWithFiles,
      isMultiBatch,
      mslaLevel,
      project,
      specificDate,
      uploadedFiles = []
    } = this.props.form.getData();

    const {
      getProjectPolicy,
      hasSubmissionSavePolicy,
      inProject
    } = PoliciesManager;
    const uploadedFilesExist = isMultiBatch ? batchesWithFiles : !!uploadedFiles.length;
    const hasSubmissionStartPolicy = inProject(project)?.hasSubmissionStartPolicy;
    const hasSubmissionAnalyzePolicy = inProject(project)?.hasSubmissionAnalyzePolicy;
    const hasSelectSuppliersButtonPolicies = getProjectPolicy(project, 'hasSelectVendorsButtonsDialogPolicy');
    const fileUploadInProgress = !this.isAllUploadEnd();
    const mslaLevelCheck = mslaLevel ? !!specificDate : true;

    return (
      <Container vBox className={'tp-page tp-clone-page'}>
        <Container
          alignItemsCenter
          className={'tp-page-header'}
          displayFlex
          justifyContentBetween
          wrap
          htmlTag={'section'}
          tabIndex={0}
        >
          <Container
            className={'tp-page-header-wrap'}
            hBox
            wrap
            alignItemsCenter
          >
            <h2 className={'tp-page-title'}>
              {this.translate('cloneSubmission')}
            </h2>
          </Container>
          <PuzzleToolbar className={'tp-page-header-action-toolbar'}>
            <PuzzleButton
              fillMode={'outline'}
              onClick={this.onCancel}
            >
              {this.translate('cancel')}
            </PuzzleButton>
            {uploadedFilesExist && hasSelectSuppliersButtonPolicies ?
              <PuzzleButton
                disabled={fileUploadInProgress}
                onClick={this.triggerSubmissionAction.bind(this, 'selectSuppliersSubmissionAction', { project })}
                themeColor={'primary'}
              >
                {this.translate('selectSuppliers')}
              </PuzzleButton> : null}
            {hasSubmissionSavePolicy ?
              <PuzzleButton
                disabled={fileUploadInProgress}
                onClick={this.triggerSubmissionAction.bind(this, 'saveSubmission', { staticFields: this.staticFields })}
                themeColor={'primary'}
              >
                {this.translate('save')}
              </PuzzleButton> : null}
            {uploadedFilesExist && hasSubmissionAnalyzePolicy ?
              <PuzzleButton
                disabled={fileUploadInProgress}
                onClick={this.triggerSubmissionAction.bind(this, 'analyzeSubmission', {})}
                themeColor={'primary'}
              >
                {this.translate('analyze')}
              </PuzzleButton> : null}
            {uploadedFilesExist && hasSubmissionStartPolicy && mslaLevelCheck ?
              <PuzzleButton
                disabled={fileUploadInProgress}
                onClick={this.triggerSubmissionAction.bind(this, 'startSubmissionDialog', { project })}
                themeColor={'primary'}
              >
                {this.translate('start')}
              </PuzzleButton> : null}
          </PuzzleToolbar>
        </Container>
        <View
          {...this.props}
          fileUploadInProgress={fileUploadInProgress}
          projectPolicies={PoliciesManager.inProject(project)}
          uploadFlowState={this.state.uploadFlowState}
        />
      </Container>
    );
  }
}

const Tpt = withFormControl(tptConfig, false)(Clone);
const Client = withFormControl(config, false)(Clone);

const CloneView = (props: { tptEnabled: boolean }): JSX.Element => {
  const mode = props.tptEnabled ? <Tpt tptEnabled={true} /> : <Client tptEnabled={false} />;
  return mode;
};

export default CloneView;

